import { AnnouncementBanner } from "~landing/components/home/announcement-banner";
import { bannerConfig } from "~landing/components/home/banner-config";
import { Benefits } from "~landing/components/home/benefits";
import { Faqs } from "~landing/components/home/faqs";
import { FeatureHighlights } from "~landing/components/home/feature-highlights";
import { Hero } from "~landing/components/home/hero";
import { HowItWorks } from "~landing/components/home/how-it-works";
import { PricingTeaser } from "~landing/components/home/pricing-teaser";
import { StartBuilding } from "~landing/components/home/start-building";
import { Testimonials } from "~landing/components/home/testimonials";
import { UseCases } from "~landing/components/home/use-cases";
import { environmentContent } from "~landing/components/environment/content";
import { MarketingPage } from "~landing/components/layout/marketing-page";

export function SolutionsEnvironmentView() {
	return (
		<MarketingPage topBanner={<AnnouncementBanner config={bannerConfig} />}>
			<Hero content={environmentContent.hero} />
			<Benefits content={environmentContent.benefits} />
			<UseCases content={environmentContent.useCases} />
			<Testimonials content={environmentContent.testimonials} />
			<HowItWorks content={environmentContent.howItWorks} />
			<Faqs content={environmentContent.faqs} />
			<FeatureHighlights content={environmentContent.featureHighlights} />
			<PricingTeaser content={environmentContent.pricingTeaser} />
			<StartBuilding content={environmentContent.startBuilding} />
		</MarketingPage>
	);
}
